export const DEFAULT_EMAIL_NOTIFY_TYPE_REF_VALUE_ID = 230;

export const RESET_ERROR = 'users/RESET_ERROR';

export const FETCH_USER_STATUS_SUCCESS = 'users/FETCH_USER_STATUS_SUCCESS';
export const FETCH_USER_STATUS_FAIL = 'users/FETCH_USER_STATUS_FAIL';

export const FETCH_USERS_SUCCESS = 'users/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAIL = 'users/FETCH_USERS_FAIL';
export const FETCH_USER_SUCCESS = 'users/FETCH_USER_SUCCESS';
export const FETCH_USER_FAIL = 'users/FETCH_USER_FAIL';
export const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'users/CREATE_USER_FAIL';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'users/UPDATE_USER_FAIL';
export const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'users/DELETE_USER_FAIL';

export const GET_USER_AVATAR = 'users/GET_USER_AVATAR';
export const GET_USER_AVATAR_SUCCESS = 'users/GET_USER_AVATAR_SUCCESS';
export const GET_USER_AVATAR_FAIL = 'users/GET_USER_AVATAR_FAIL';
export const SET_USER_AVATAR_SUCCESS = 'users/SET_USER_AVATAR_SUCCESS';
export const SET_USER_AVATAR_FAIL = 'users/SET_USER_AVATAR_FAIL';

export const REINVITE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const REINVITE_USER_FAIL = 'users/DELETE_USER_FAIL';

export const DELETE_USER_PARTNER_APP_LOGIN_SUCCESS = 'users/DELETE_USER_PARTNER_APP_LOGIN_SUCCESS';
export const DELETE_USER_PARTNER_APP_LOGIN_FAIL = 'users/DELETE_USER_PARTNER_APP_LOGIN_FAIL';

export const FETCH_OFFICE_USER_SUCCESS = 'users/FETCH_OFFICE_USER_SUCCESS';
export const FETCH_OFFICE_USER_FAIL = 'users/FETCH_OFFICE_USER_FAIL';
export const CREATE_OFFICE_USER_SUCCESS = 'users/CREATE_OFFICE_USER_SUCCESS';
export const CREATE_OFFICE_USER_FAIL = 'users/CREATE_OFFICE_USER_FAIL';
export const DELETE_OFFICE_USER_SUCCESS = 'users/DELETE_OFFICE_USER_SUCCESS';
export const DELETE_OFFICE_USER_FAIL = 'users/DELETE_OFFICE_USER_FAIL';
export const UPDATE_OFFICE_USER_REDUX = 'users/UPDATE_OFFICE_USER_REDUX';

export const CHECK_EMAIL_SUCCESS = 'users/CHECK_EMAIL_SUCCESS';
export const CHECK_EMAIL_FAIL = 'users/CHECK_EMAIL_FAIL';
export const CHECK_EMAIL = 'users/CHECK_EMAIL';
